<div>
  <div class="metric-card-holder">
    @if (activeUsersCurrentData$ | async; as activeUsers) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.activeUsers.header"
        [currentPeriod]="activeUsersCurrentValue$ | async"
        [previousPeriod]="activeUsersPrevValue$ | async"
        [isEmpty]="activeUsersIsEmpty$ | async"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [gradient]="false"
            [customColors]="cardConfig.activeUsers.chartColors"
            [results]="activeUsers"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateActiveUsers let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model.value }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateActiveUsers let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model[0].value }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="activeUsersLoading"></ng-container>
    }

    @if (sessionsCurrentData$ | async; as sessions) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.sessions.header"
        [currentPeriod]="sessionsCurrentValue$ | async"
        [previousPeriod]="sessionsPrevValue$ | async"
        [isEmpty]="sessionsIsEmpty$ | async"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [gradient]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [customColors]="cardConfig.sessions.chartColors"
            [results]="sessions"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateSessions let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model.value }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateSessions let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model[0].value }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="sessionsLoading"></ng-container>
    }

    @if (sessionDurationCurrentData$ | async; as sessionDuration) {
      <app-metrics-card
        class="one-third-card relative-chart-inner-container"
        [header]="cardConfig.sessionDuration.header"
        [currentPeriod]="sessionDurationCurrentValue$ | async"
        [formatValueDisplayFunc]="convertSecondsToHHMMSS"
        [previousPeriod]="avgSessionDurationPrevValue$ | async"
        [isEmpty]="sessionDurationIsEmpty$ | async"
        [graphName]="'sessionDuration'"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [gradient]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [customColors]="cardConfig.sessionDuration.chartColors"
            [results]="sessionDuration"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateSessionDuration let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ convertGraphSecondsToHHMMSS(model.value) }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateSessionDuration let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ convertGraphSecondsToHHMMSS(model[0].value) }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="sessionDurationLoading"></ng-container>
    }

    @if (pageViewsCurrentData$ | async; as pageViews) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.pageViews.header"
        [currentPeriod]="pageViewsCurrentValue$ | async"
        [previousPeriod]="pageViewsPrevValue$ | async"
        [isEmpty]="pageViewsIsEmpty$ | async"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [gradient]="false"
            [customColors]="cardConfig.pageViews.chartColors"
            [results]="pageViews"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplatePageViews let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model.value }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplatePageViews let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model[0].value }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="pageViewsLoading"></ng-container>
    }

    @if (pageViewsPerSessionCurrentData$ | async; as pageViewsPerSession) {
      <app-metrics-card
        class="one-third-card relative-chart-inner-container"
        [header]="cardConfig.pageViewsPerSession.header"
        [currentPeriod]="pageViewsPerSessionCurrentValue$ | async"
        [previousPeriod]="pageViewsPerSessionPrevValue$ | async"
        [isEmpty]="pageViewsPerSessionIsEmpty$ | async"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [gradient]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [customColors]="cardConfig.pageViewsPerSession.chartColors"
            [results]="pageViewsPerSession"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplatePageViewsPerSession let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model.value.toFixed(2) }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplatePageViewsPerSession let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model[0].value.toFixed(2) }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="pageViewsPerSessionLoading"></ng-container>
    }

    @if (newUsersCurrentData$ | async; as newUsers) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.newUsers.header"
        [currentPeriod]="newUsersCurrentValue$ | async"
        [previousPeriod]="newusersPrevValue$ | async"
        [isEmpty]="newUsersIsEmpty$ | async"
      >
        <div header-content class="analytics-charts">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [gradient]="false"
            [customColors]="cardConfig.newUsers.chartColors"
            [results]="newUsers"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateNewUsers let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model.value }}
                </div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateNewUsers let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">
                  {{ model[0].value }}
                </div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="newUsersLoading"></ng-container>
    }

    @if (bounceRateCurrentData$ | async; as bounceRate) {
      <app-metrics-card
        class="half-width-card"
        [header]="cardConfig.bounceRate.header"
        [currentPeriod]="bounceRateCurrentValue$ | async"
        [formatValueDisplayFunc]="formatBounceRate"
        [previousPeriod]="bounceRatePrevValue$ | async"
        [isEmpty]="bounceRateIsEmpty$ | async"
        [graphName]="'bounceRate'"
      >
        <div header-content class="analytics-charts-BounceRate">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [gradient]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [customColors]="cardConfig.bounceRate.chartColors"
            [results]="bounceRate"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateBounceRate let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">{{ model.value.toFixed(2) }} %</div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateBounceRate let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">{{ model[0].value.toFixed(2) }} %</div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="bounceRateLoading"></ng-container>
    }

    @if (engSessionCurrentData$ | async; as engagedSessions) {
      <app-metrics-card
        class="half-width-card"
        [header]="cardConfig.engagedSessions.header"
        [currentPeriod]="enagagedSessionsCurrentValue$ | async"
        [previousPeriod]="engSessionsPrevValue$ | async"
        [isEmpty]="enagagedSessionsIsEmpty$ | async"
        [graphName]="'engagedSessions'"
      >
        <div header-content class="analytics-charts-BounceRate">
          <ngx-charts-line-chart
            class="force-hover-state"
            [autoScale]="true"
            [gradient]="true"
            [scheme]="colorScheme"
            [schemeType]="schemeType"
            [customColors]="cardConfig.engagedSessions.chartColors"
            [results]="engagedSessions"
            [animations]="false"
            [xAxis]="true"
            [yAxis]="true"
            [xAxisTickFormatting]="formatMonthString"
            [yAxisTickFormatting]="formatYAxisScale"
          >
            <ng-template #tooltipTemplateEngagedSessions let-model="model">
              @if (model) {
                <div class="chart-layout-top">
                  {{ model.series.key | translate }}
                  {{ ' &bull; ' + model.name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">{{ model.value }} %</div>
              }
            </ng-template>
            <ng-template #seriesTooltipTemplateEngagedSessions let-model="model">
              @if (model[0]) {
                <div class="chart-layout-top">
                  {{ model[0].series.key | translate }}
                  {{ ' &bull; ' + model[0].name.toLocaleDateString() }}
                </div>
                <div class="chart-layout-bottom">{{ model[0] }} %</div>
              }
            </ng-template>
          </ngx-charts-line-chart>
        </div>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="engSessionLoading"></ng-container>
    }

    @if (trafficSourceData$ | async; as trafficSourceData) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.trafficSources.header"
        [graphName]="'trafficSources'"
        [isEmpty]="!trafficSourceData?.length"
      >
        <app-ga-table
          [sourceData]="trafficSourceData"
          [dataType]="'percentage'"
          [columnConfig]="cardConfig.trafficSources.columnConfig"
        ></app-ga-table>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="trafficSourceDataLoading"></ng-container>
    }

    @if (topReferralSourceData$ | async; as topReferralSourceData) {
      <app-metrics-card
        class="one-third-card"
        [header]="cardConfig.topReferralSources.header"
        [graphName]="'topReferralSources'"
        [isEmpty]="!topReferralSourceData?.length"
      >
        <app-ga-table
          [sourceData]="topReferralSourceData"
          [dataType]="'percentage'"
          [columnConfig]="cardConfig.topReferralSources.columnConfig"
        ></app-ga-table>
      </app-metrics-card>
    } @else {
      <ng-container [ngTemplateOutlet]="topReferralSourceDataLoading"></ng-container>
    }

    @if (defaultTracking === false) {
      @if (goals$ | async; as goalsData) {
        <div class="full-width-card">
          <mat-card appearance="outlined">
            <va-goal-table [dataSource]="goalsData" [tableConfig]="cardConfig.goals"></va-goal-table>
          </mat-card>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="goalsLoading"></ng-container>
      }
    }

    <ng-template #activeUsersLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.activeUsers.header"></app-loading-state-card>
    </ng-template>

    <ng-template #sessionsLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.sessions.header"></app-loading-state-card>
    </ng-template>

    <ng-template #pageViewsLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.pageViews.header"></app-loading-state-card>
    </ng-template>

    <ng-template #sessionDurationLoading>
      <app-loading-state-card
        class="one-third-card"
        [header]="cardConfig.sessionDuration.header"
      ></app-loading-state-card>
    </ng-template>

    <ng-template #pageViewsPerSessionLoading>
      <app-loading-state-card
        class="one-third-card"
        [header]="cardConfig.pageViewsPerSession.header"
      ></app-loading-state-card>
    </ng-template>

    <ng-template #newUsersLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.newUsers.header"></app-loading-state-card>
    </ng-template>

    <ng-template #bounceRateLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.bounceRate.header"></app-loading-state-card>
    </ng-template>

    <ng-template #engSessionLoading>
      <app-loading-state-card class="one-third-card" [header]="cardConfig.bounceRate.header"></app-loading-state-card>
    </ng-template>

    <ng-template #trafficSourceDataLoading>
      <app-loading-state-card
        class="one-third-card"
        [header]="cardConfig.trafficSources.header"
      ></app-loading-state-card>
    </ng-template>

    <ng-template #topReferralSourceDataLoading>
      <app-loading-state-card
        class="one-third-card"
        [header]="cardConfig.topReferralSources.header"
      ></app-loading-state-card>
    </ng-template>

    <ng-template #goalsLoading>
      <app-loading-state-card class="full-width-card" [header]="cardConfig.goals.header"></app-loading-state-card>
    </ng-template>
  </div>
</div>
